"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Infoblock = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@erm-tasku/components");
const AppContext_1 = require("../contexts/AppContext");
const react_i18next_1 = require("react-i18next");
const Infoblock = ({ children, onClose, visible }) => {
    const { t } = react_i18next_1.useTranslation();
    const { markers, selectedMarker, setSelectedMarker } = AppContext_1.useAppContext();
    function onNext() {
        const nextIndex = markers.indexOf(selectedMarker) + 1;
        if (nextIndex < markers.length) {
            setSelectedMarker(markers[nextIndex]);
        }
        else {
            setSelectedMarker(markers[0]);
        }
    }
    function onPrev() {
        const prevIndex = markers.indexOf(selectedMarker) - 1;
        if (prevIndex >= 0) {
            setSelectedMarker(markers[prevIndex]);
        }
        else {
            setSelectedMarker(markers[markers.length - 1]);
        }
    }
    return (react_1.default.createElement(components_1.Overlay, null,
        react_1.default.createElement(components_1.InfoBox, { visible: visible }, children),
        react_1.default.createElement(components_1.ButtonContainer, null, visible && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(components_1.Button, { onClick: onClose },
                react_1.default.createElement(components_1.CloseIcon, { "aria-label": t('ui.close') })),
            react_1.default.createElement(components_1.Button, { onClick: onNext },
                react_1.default.createElement(components_1.RightArrow, { "aria-label": t('ui.next') })),
            react_1.default.createElement(components_1.Button, { onClick: onPrev },
                react_1.default.createElement(components_1.LeftArrow, { "aria-label": t('ui.previous') })))))));
};
exports.Infoblock = Infoblock;
